import api from '../api'; // از فایل api اصلی import کنید

export const productApi = {
  // ایجاد محصول جدید
  create: (data) => api.post('/products/products/', data),

  // دریافت محصول
  get: (id) => api.get(`/products/products/${id}/`),

  // مخصوص فروشگاه
  getBySlug: (slug) => api.get(`/products/shopping/${slug}/`),

  // بروزرسانی محصول
  update: (id, data) => api.patch(`/products/products/${id}/`, data,
      {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
        ),

  // ذخیره خودکار
  autoSave: (data) => api.post('/products/products/auto_save/', data),

  // ارسال برای تأیید
  submit: (id) => api.post(`/products/products/${id}/submit/`),

  // ساخت محصول مشابه
  duplicate: (id) => api.post(`/products/products/${id}/duplicate/`),

  delete: (id) => api.delete(`/products/products/${id}/`),


  getList: (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    return api.get(`/products/products/?${queryString}`);
  },
  getExportExcelList: (params = {}) => {
      const queryString = new URLSearchParams(params).toString();
      return api.get(`/products/products/export/?${queryString}`);
    },

  uploadImages: (id, imageItems) => {
    const formData = new FormData();

    // ساخت متادیتا
    const imagesMetadata = imageItems.map((item, index) => ({
      id: item.id, // برای شناسایی عکس‌ها در بک‌اند
      order: index,
      is_featured: !!item.is_featured
    }));

    // اضافه کردن فایل‌ها به فرم‌دیتا
    imageItems.forEach(image => {
      // فقط عکس‌هایی که فایل هستند (جدید آپلود شده‌اند) را ارسال می‌کنیم
      if (image.file instanceof File) {
        formData.append('uploaded_images', image.file);
      }
    });

    // ارسال متادیتا به صورت JSON
    formData.append('images_metadata', JSON.stringify(imagesMetadata));

    return api.post(`/products/products/${id}/upload_images/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  deleteImage: (productId, imageId) =>
    api.delete(`/products/products/${productId}/delete_image/`, {
      data: { image_id: imageId }
    }),

  // دریافت تاریخچه تغییرات محصول
  getProductHistory: (id) => api.get(`/products/products/${id}/history/`),

  // دریافت وضعیت تأیید
  getApprovalStatus: (id) => api.get(`/products/products/${id}/approval/`),
};

export const categoryApi = {
  // دریافت دسته‌های برگ
  getLeaves: () => api.get('/products/categories/leaves/'),

  // دریافت مشخصه‌های یک دسته
  getAttributes: (categoryId) => api.get(`/products/categories/${categoryId}/attributes/`),

  // جستجو در دسته‌ها
  search: (query) => api.get(`/products/categories/?search=${query}`),
};

